module.exports = __webpack_public_path__ + "img/icon-mis-libros.36a3783e.svg";